import lazyLoading from './lazyLoading'

export default {
  name: 'trips',
  meta: {
    expanded: false,
    title: 'Viajes',
    iconClass: 'fa fa-taxi'
  },
  children: [
    {
      name: 'tripsFinished',
      path: '/trips/trip-finished',
      component: lazyLoading('trips/Main'),
      meta: {
        title: 'Viajes',
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('trips/Finished'),
          meta: {
            title: 'Finalizado',
          }
        },
        {
          name: 'tripView',
          path: ':travelId',
          component: lazyLoading('trips/View'),
          props: true,
          meta: {
            title: 'Finalizado',
          }
        }
      ]
    },
    {
      name: 'trips-queue-list',
      path: '/trips/queue-list',
      component: lazyLoading('trips/Main'),
      meta: {
        title: 'Solicitudes',
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('trips/QueueList'),
          meta: {
            title: 'Solicitud',
          }
        },
        {
          path: ':queueId',
          component: lazyLoading('trips/QueueView2'),
          props: true,
          meta: {
            title: 'Vista',
          }
        }
      ]
    },
    /*
    {
      path: '/trips/to-be-assigned',
      component: lazyLoading('trips/Main'),
      meta: {
        title: 'Por Asignar'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('trips/ToBeAssigned'),
          meta: {
            title: 'Por Asignar'
          }
        },
        {
          path: ':queueId',
          component: lazyLoading('trips/ViewQueue'),
          props: true,
          meta: {
            title: 'Por Asignar'
          }
        }
      ]
    },
    */
    {
      name: 'tripsScheduledTrip',
      path: '/trips/scheduled-trip',
      component: lazyLoading('trips/Main'),
      meta: {
        title: 'Programado',
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('trips/Scheduled'),
          meta: {
            title: 'Programado',
          }
        },
        {
          name: 'queueView',
          path: ':queueId',
          component: lazyLoading('trips/ViewQueue'),
          props: true,
          meta: {
            title: 'Programado',
          }
        }
      ]
    },
    {
      name: 'scanQueue',
      path: '/trips/scan-queue',
      component: lazyLoading('travels/ScanQueue'),
      meta: {
        title: 'Escaneos de Boletos',
        requiresAuth: true
      }
    },
    /*
    {
      path: '/trips/trip-in-progress',
      component: lazyLoading('trips/Main'),
      meta: {
        title: 'En Curso',
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('trips/InProgress'),
          meta: {
            title: 'En Curso',
          }
        },
        {
          path: ':travelId',
          component: lazyLoading('trips/View'),
          props: true,
          meta: {
            title: 'En Curso',
          }
        }
      ]
    }
    */
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/trips.js